import { AppRoutes } from "./router";
import { BrowserRouter } from "react-router-dom";
import BackgroundMusic from "./components/feature/BackgroundMusic";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <BackgroundMusic />
    </BrowserRouter>
  );
}

export default App;